import script from "./AdminToolsTabPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminToolsTabPanel.vue?vue&type=script&setup=true&lang=js"

import "./AdminToolsTabPanel.vue?vue&type=style&index=0&id=160af422&lang=sass&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-160af422"]])

export default __exports__
import QLayout from 'quasar/src/components/layout/QLayout.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QTabs from 'quasar/src/components/tabs/QTabs.js';
import QRouteTab from 'quasar/src/components/tabs/QRouteTab.js';
import QPageSticky from 'quasar/src/components/page-sticky/QPageSticky.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QLayout,QImg,QTabs,QRouteTab,QPageSticky});
